export default [
  { title: "HTTP Result codes", icon: "", link: "/docs/error/http-result" },
  { title: "Error", icon: "", link: "/docs/error/erros" },
  { title: "Error Scope", icon: "", link: "/docs/error/error-scope" },
  { title: "Error Code", icon: "", link: "/docs/error/error-code" },	
];
